import React from "react"

const ReferralContext = React.createContext({
  referrerId: null,
  userReferralId: null,
})

export default ReferralContext
